import { apiClient } from './api-client';

/**
 * Where `DirectUploadProvider` should post a file: the API's host, which in the
 * apps is not the page's own. Falls back to the page's host when the API is
 * served from it.
 */
export function directUploadOrigin() {
  const fallback = {
    host: window.location.hostname,
    port: window.location.port || undefined,
    protocol: window.location.protocol.replace(':', ''),
  };
  const baseURL = apiClient.getBaseURL();
  if (!baseURL) return fallback;
  try {
    const url = new URL(baseURL);
    return { host: url.hostname, port: url.port || undefined, protocol: url.protocol.replace(':', '') };
  } catch {
    return fallback;
  }
}
